import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import About from "@/pages/about/About";
import Greeting from "@/pages/about/Greeting";
import History from "@/pages/about/History";
import Officers from "@/pages/about/Officers";
import NoticeList from "@/pages/notices/NoticeList";
import NoticeDetail from "@/pages/notices/NoticeDetail";
import Bizmap from "@/pages/bizmap/page";
import CardsPage from "@/pages/cards/page";
import MembersPage from "@/pages/members/page";
import MemberDetail from "@/pages/members/detail/page";
import PromoPage from "@/pages/promo/page";
import PromoWritePage from "@/pages/promo/write/page";
import PromoDetailPage from "@/pages/promo/detail/page";
import FreePage from "@/pages/free/page";
import FreeDetailPage from "@/pages/free/detail/page";
import FreeWritePage from "@/pages/free/write/page";
import CalendarPage from "@/pages/calendar/page";
import LadderPage from "@/pages/ladder/page";
import LadderDetailPage from "@/pages/ladder/detail/page";
import GalleryPage from "@/pages/gallery/page";
import GalleryDetailPage from "@/pages/gallery/detail/page";
import ContactPage from "@/pages/contact/page";
import MyProfilePage from "@/pages/my/profile/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },

      // 클럽소개
      { path: "/about", element: <About /> },
      { path: "/about/greeting", element: <Greeting /> },
      { path: "/about/history", element: <History /> },
      { path: "/about/officers", element: <Officers /> },

      // 명함
      { path: "/cards", element: <CardsPage /> },

      // 회원
      { path: "/members", element: <MembersPage /> },
      { path: "/members/:no", element: <MemberDetail /> },

      // 민들레 비즈맵
      { path: "/bizmap", element: <Bizmap /> },

      // 직업홍보
      { path: "/promo", element: <PromoPage /> },
      { path: "/promo/write", element: <PromoWritePage /> },
      { path: "/promo/:no", element: <PromoDetailPage /> },

      // 자유글
      { path: "/free", element: <FreePage /> },
      { path: "/free/write", element: <FreeWritePage /> },
      { path: "/free/:no", element: <FreeDetailPage /> },

      // 클럽 일정 (출근도장 · 일정 · 생일 통합)
      { path: "/calendar", element: <CalendarPage /> },

      // 옛 출근도장 경로는 일정으로 리다이렉트
      { path: "/attend", element: <Navigate to="/calendar" replace /> },

      // 사다리게임
      { path: "/ladder", element: <LadderPage /> },
      { path: "/ladder/:no", element: <LadderDetailPage /> },

      // 활동갤러리
      { path: "/gallery", element: <GalleryPage /> },
      { path: "/gallery/:no", element: <GalleryDetailPage /> },

      // 공지사항
      { path: "/notices", element: <NoticeList /> },
      { path: "/notices/:no", element: <NoticeDetail /> },

      // 문의하기
      { path: "/contact", element: <ContactPage /> },

      // 내 명함 수정
      { path: "/my/profile", element: <MyProfilePage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;